import { DynamicCopyType } from '@caresend/types';

const isDCTitleSubtitle = (input) => input.copyTypes.includes(DynamicCopyType.TITLE_SUBTITLE);
const isDCLink = (input) => input.copyTypes.includes(DynamicCopyType.LINK);
const isDCForm = (input) => input.copyTypes.includes(DynamicCopyType.FORM);
const isDCEmbed = (input) => input.copyTypes.includes(DynamicCopyType.EMBED);
/**
 * Given store.state and a path to an expected value, return the value if it exists.
 *
 * For an example see how `email` is configured in `variables.dynamicCopy.symbols`
 */
const getObjectValueFromPath = (
/** Must declare `any` to support recursive typing for nested store references. */
object, path) => {
    const [firstKey, ...rest] = path.split('.');
    if (!firstKey)
        return;
    if (!object)
        return;
    const objectHasValue = Object.prototype.hasOwnProperty.call(object, firstKey);
    if (!objectHasValue)
        return;
    const curr = object[firstKey];
    if (rest.length === 0)
        return curr;
    return getObjectValueFromPath(curr, rest.join('.'));
};
/**
 * String input with '{{ symbolName }}' will be replaced with the value of the symbol if found
 */
const replaceSymbols = (input, symbols) => {
    if (!input)
        return;
    let result = input;
    Object.entries(symbols).forEach(([symbol, value]) => {
        result = result.replaceAll(new RegExp(`{{ ${symbol} }}`, 'g'), value);
    });
    return result;
};

export { getObjectValueFromPath, isDCEmbed, isDCForm, isDCLink, isDCTitleSubtitle, replaceSymbols };
